import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PhygitalIcon from "@/components/PhygitalIcon";
import PitchDeckSlides from "@/components/investor/PitchDeckSlides";
import { Lock, ArrowLeft, Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const DECK_PASSWORD = "phygital2026";

const PitchDeckPage = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem("pitchdeck_auth") === "true";
  });
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === DECK_PASSWORD) {
      sessionStorage.setItem("pitchdeck_auth", "true");
      setIsAuthenticated(true);
      setError("");
    } else {
      setError("Incorrect password");
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-emerald-50/30 flex items-center justify-center p-4">
        <div className="max-w-sm w-full">
          <div className="text-center mb-8">
            <PhygitalIcon className="w-16 h-16 mx-auto mb-4" variant="light" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Pitch Deck</h1>
            <p className="text-sm text-gray-500">Enter the access code to view</p>
          </div>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <Input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(""); }}
                placeholder="Access code"
                className="pl-10 pr-10"
                data-testid="pitchdeck-password"
                autoFocus
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
            {error && <p className="text-sm text-red-500 text-center">{error}</p>}
            <Button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="pitchdeck-submit">
              View Deck
            </Button>
          </form>
          <button
            onClick={() => navigate("/")}
            className="mt-6 flex items-center gap-2 text-sm text-gray-400 hover:text-gray-600 mx-auto"
          >
            <ArrowLeft className="w-4 h-4" /> Back to home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="pitchdeck-page">
      {/* Fixed back button */}
      <button
        onClick={() => navigate("/")}
        className="fixed top-4 left-4 z-50 flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 bg-white/80 backdrop-blur-sm px-3 py-2 rounded-lg shadow-sm border border-gray-200"
      >
        <ArrowLeft className="w-4 h-4" /> Home
      </button>
      
      {/* Render the inline-editable PitchDeckSlides */}
      <PitchDeckSlides />
    </div>
  );
};

export default PitchDeckPage;
